<div class="center-content-login">

  <div style="padding: 3%; background-color: white" class="medium-border-arma-color">
    <div class="factory-name">{{HTML_FactoryName}}</div>
    <div style="text-align: center;">
      <img *ngIf="HTML_AdressFactoryLogo != ''" style=" height: 150px" [src]="HTML_AdressFactoryLogo">
    </div>

    <div style="text-align: center">
      <span>
        <mat-form-field class="input-form-inputField">
          <input #inputLogin matInput
            [disabled]="mLockInProgress"
            placeholder="{{ 'Identifiant' | translate }}"
            autocomplete="off"
            [(ngModel)]="HTML_Username"
            id="login-input-login"
            (keyup.Enter)='focusPassword()'>
        </mat-form-field>
      </span>
      <span>
        <mat-form-field class="input-form-inputField input-login-password">
          <input #inputPassword matInput
            [disabled]="mLockInProgress"
            placeholder="{{ 'Mot de passe' | translate }}"
            [type]="HTML_Password_hide ? 'password' : 'text'"
            [(ngModel)]="HTML_Password"
            id="login-input-password"
            autocomplete="off"
            (keyup.Enter)='connect()'>
          <button mat-icon-button matSuffix (click)="HTML_Password_hide = !HTML_Password_hide"
            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="HTML_Password_hide">
            <mat-icon>{{HTML_Password_hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>
      </span>
    </div>

    <div style="text-align: center">
      <button mat-raised-button
        class="button-connect"
        (click)="connect()"
        [disabled]="mLockInProgress">{{'Connexion' | translate}}</button>
      <mat-spinner style="margin: 5px auto;" diameter="50" *ngIf="mLockInProgress"></mat-spinner>
    </div>
    <div class="login-error-message">
      {{HTML_Result}}
    </div>

    <app-select-language style="text-align: center"></app-select-language>

  </div>
</div>
